import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img 
            src="/images/logo.svg" 
            alt="UpNorth Impact Logo" 
            className="logo-image"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <span className="navbar-divider" aria-hidden="true">|</span>
          <h3 className="navbar-tagline">Expose. Educate. Engage.</h3>
        </Link>
        <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`navbar-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`navbar-link ${isActive('/about') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            About
          </Link>
          <Link 
            to="/services" 
            className={`navbar-link ${isActive('/services') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Services
          </Link>
          <Link 
            to="/media" 
            className={`navbar-link ${isActive('/media') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Media
          </Link>
          <Link 
            to="/contact" 
            className={`navbar-link ${isActive('/contact') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Contact
          </Link>
          <Link 
            to="/admin" 
            className={`navbar-link ${isActive('/admin') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Admin
          </Link>
        </div>
        <div 
          className={`navbar-toggle ${isOpen ? 'active' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
